var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 100,
    viewBox: "0 0 97 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.242 83.3333C96.242 92.5 89.0238 100 80.2016 100H16.0403C7.21815 100 0 92.5 0 83.3333V16.6667C0 7.5 7.21815 0 16.0403 0H80.2016C89.0238 0 96.242 7.5 96.242 16.6667V83.3333Z",
    fill: "#563D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1518 21.7323H53.4361C58.4683 21.7323 62.5099 22.9251 65.545 25.327C68.58 27.729 70.1054 31.3401 70.1054 36.1931C70.1054 39.1342 69.4135 41.6506 68.0296 43.7421C66.6458 45.8336 64.6643 47.4676 62.0853 48.6114V48.7748C65.545 49.5427 68.1712 51.2421 69.9482 53.8728C71.7252 56.5199 72.6216 59.8205 72.6216 63.8074C72.6216 66.095 72.2284 68.2355 71.4421 70.2127C70.6558 72.2061 69.4292 73.9218 67.7466 75.3597C66.0639 76.7976 63.9252 77.9414 61.299 78.7911C58.6728 79.6408 55.5591 80.0656 51.9421 80.0656H26.1518V21.7323ZM35.9804 46.1604H52.0208C54.3796 46.1604 56.3454 45.4741 57.9179 44.0689C59.4905 42.6636 60.2768 40.6702 60.2768 38.0558C60.2768 35.1146 59.5691 33.0395 58.1538 31.8466C56.7385 30.6538 54.6941 30.0493 52.0208 30.0493H35.9804V46.1604ZM35.9804 71.7323H53.3575C56.3454 71.7323 58.6728 70.9316 60.3083 69.314C61.9595 67.7127 62.7929 65.4251 62.7929 62.4839C62.7929 59.5917 61.9752 57.3859 60.3083 55.8172C58.6413 54.2486 56.3454 53.497 53.3575 53.497H35.9804V71.7323Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.242,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.ca0583efa07a54105aa5bd4064dc7ecf.svg";
export { ForwardRef as ReactComponent };